<div class="sb-avatar" style="width:34px;height:34px;font-size:11px;background:#1B3A6B;">{{auth.initials()}}</div>
